const NotFoundInterceptor = require('./interceptors/http-not-found-interceptor');
const SuccessInterceptor = require('./interceptors/http-success-interceptor');

module.exports = function ($httpProvider, $provide) {
    //$httpProvider.defaults.headers.common = {};
    //$httpProvider.defaults.headers.post = {};
    //$httpProvider.defaults.headers.put = {};
    //$httpProvider.defaults.headers.patch = {};
    $provide.factory('http401Interceptor', [
        '$q', '$injector', '$window', 'LoadingIndicatorService', 'whiteList',
            NotFoundInterceptor
    ]);

    $provide.factory('http200Interceptor', [
        '$rootScope', 'LoadingIndicatorService', SuccessInterceptor
    ]);

    $httpProvider.interceptors.push('http401Interceptor');
    $httpProvider.interceptors.push('http200Interceptor');
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/http.js
 **/